// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {DigitalUserAddress} from './digital-user-address';
import {DigitalUserOrganization} from './digital-user-organization';

export const DigitalUserResult = t.struct({
    address: t.maybe(DigitalUserAddress),
    applicationsAccessed: t.maybe(t.list(t.String)),
    countryCode: t.maybe(t.String),
    email: t.maybe(t.String),
    formattedName: t.maybe(t.String),
    homeNumber: t.maybe(t.String),
    lastUsed: t.maybe(t.String),
    mobileNumber: t.maybe(t.String),
    mobilePhoneVerifiedStatus: t.maybe(t.String),
    organizations: t.maybe(t.list(DigitalUserOrganization)),
    userName: t.maybe(t.String),
    userStatus: t.maybe(t.String),
    username: t.maybe(t.String),
    workNumber: t.maybe(t.String)
}, {
    defaultProps: {
        address: null,
        applicationsAccessed: [],
        countryCode: '',
        email: '',
        formattedName: '',
        homeNumber: '',
        lastUsed: '',
        mobileNumber: '',
        mobilePhoneVerifiedStatus: '',
        organizations: [],
        userName: '',
        userStatus: '',
        username: '',
        workNumber: ''
    },
    name: 'DigitalUserResult',
    strict: false
});

export const DigitalUserResults = t.list(DigitalUserResult, 'DigitalUserResults');
